import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { AI_STEPS } from '../mock';

export default function AIGovernance() {
  return (
    <section id="ai" className="py-24 md:py-32 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="eyebrow mono-font text-black/60">AI Governance</div>
            <h2 className="display-font mt-8 text-[10vw] md:text-[4.6rem] leading-[0.95]">
              Stable AI, <span className="accent-red">company-wide.</span>
            </h2>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-x-16 md:gap-y-14">
          {AI_STEPS.map((step) => (
            <div key={step.n} className="group">
              <div className="num-font text-3xl accent-red">{step.n}</div>
              <h3 className="display-font mt-4 text-2xl md:text-[1.7rem] text-black">{step.title}</h3>
              <p className="mt-3 text-black/60 max-w-lg">{step.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-black/10 bg-grid bg-white p-8 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <div className="mono-font text-black/50">Ready to govern your AI stack?</div>
            <p className="display-font mt-3 text-2xl md:text-3xl text-black leading-tight max-w-2xl normal-case" style={{ textTransform: 'none' }}>
              Get a readiness audit and a cost-optimisation plan tailored to your organisation.
            </p>
          </div>
          <a href="#contact" className="btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-semibold whitespace-nowrap">
            Book an AI Audit <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
